import appStore from 'store';
import api from './api';
import {
  REGISTER_FORM,
  USER_STATUS,
  BANK_AUTH_STATUS,
  ID_NO_STATUS,
  EMAIL_SECURITY_STATUS,
  PHONE_SECURITY_STATUS,
  GOOGLE_SECURITY_STATUS,
  USER_VALUNTEER_STATUS,
  USER_BLOCKING_STATUS,
  QUERY_TYPE,
  SUB_TYPE,
  PAGINATION
} from './constants';

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,
    queryTypeList: QUERY_TYPE,
    subTypeList: SUB_TYPE,
    queryType: QUERY_TYPE[0].value,
    subType: SUB_TYPE[0].value,
    queryValue: ''
  },
  getters: {
    userList: state =>
        state.userList.map(item => {
          return {
            ...item,
            __registerFrom: REGISTER_FORM[item.registerFrom || "email"],
            __userStatus: USER_STATUS[item.userStatus || 0],
            __bankAuthStatus: BANK_AUTH_STATUS[item.bankAuthStatus || 0],
            __idNoStatus: ID_NO_STATUS[item.identityAuthType || 0][item.idNoStatus || 0],
            // __idNoStatus: ID_NO_STATUS[item.idNoStatus || 0],
            __emailSecurityStatus:
                EMAIL_SECURITY_STATUS[item.emailSecurityStatus || 0],
            __phoneSecurityStatus:
                PHONE_SECURITY_STATUS[item.phoneSecurityStatus || 0],
            __googleSecurityStatus:
                GOOGLE_SECURITY_STATUS[item.googleSecurityStatus || 0],
            __userVolunteerStatus:
                USER_VALUNTEER_STATUS[item.userVolunteerStatus || 0],
            __userBlockingStatus: USER_BLOCKING_STATUS[item.userStatus || 0]
          };
        }),
    queryType: state => state.queryType,
    subType: state => state.subType,
    queryValue: state => state.queryValue
  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setQueryType(state, payload) {
      state.queryType = payload;
    },
    setSubType(state, payload) {
      state.subType = payload;
    },
    setQueryValue(state, payload) {
      state.queryValue = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      commit('setPagination', { page: query.page, size: query.size });
      commit('setQueryType', query.queryType);
      commit('setSubType', query.subType);
      commit('setQueryValue', query.queryValue);
      api.getUserList(query).then(({ data }) => {
        commit('setUserList', data);
      });
    },
    updateVolunteer({ commit }, data) { // eslint-disable-line
      return new Promise(resolve => {
        api.updateVolunteer(data).then(res => {
          resolve(res);
        });
      });
    },
    resetPassword({ commit }, data){
      return new Promise(resolve => {
        api.resetPassword(data).then(res => {
          resolve(res)
        })
      })
    },
    resetGoogle({ commit }, data){
      return new Promise(resolve => {
        api.resetGoogle(data).then(res => {
          resolve(res)
        })
      })
    },
    cleanLoginForbid({ commit }, data){
      return new Promise(resolve => {
        api.cleanLoginForbid(data).then(res => {
          resolve(res)
        })
      })
    },
    updateBlocking({ commit }, data) {
      return new Promise(resolve => {
        api.updateBlocking(data).then(res => {
          resolve(res);
        });
      });
    },
    unBindSub({ commit }, data) {
      return new Promise(resolve => {
        api.unBindSub(data).then(res => {
          resolve(res);
        });
      });
    },
    addBindSub({ commit }, data) {
      return new Promise(resolve => {
        api.addBindSub(data).then(res => {
          resolve(res);
        });
      });
    },
    alterTradeUserMsg({ commit }, data) {
      return new Promise(resolve => {
        api.alterTradeUserMsg(data).then(res => {
          resolve(res);
        });
      });
  }
  }
};

appStore.registerModule('userSub', store);
